<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

    <z-page title="Proses Penyesuaian Manual">

        <div class="message-box">
          <w-transition-fade>
            <w-alert
              class="my0 text-light"
              v-if="form.submitted"
              success
              no-border>
              The form is valid, ready to send it!
            </w-alert>

            <w-alert
              class="my0 text-light"
              v-else-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
            </w-alert>
          </w-transition-fade>
        </div>

        <w-form
          class=""
          v-model="form.valid"
          v-model:errors-count="form.errorsCount"
          @validate="upload"
          @success="onSuccess">
          <w-card bg-color="" class="">
            <w-flex class="mt3">
                <div class="xs6 mr5">
                  <w-input
                    type="file"
                    placeholder="Sila Muatnaik Fail Penyata Bank" 
                    required
                    v-model="files"
                    label="Nama Fail Penyata Bank" />
                </div>
                <div class="xs6">
                    <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                        <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Semak
                    </w-button>
                </div>

            </w-flex>
          </w-card>
          <br>

          <w-card bg-color="" class="">
            
            <w-flex justify-space-between class="mb4">
              <label>Jumlah Rekod : {{data.padan}}</label> 
            </w-flex>
            <w-flex justify-space-between class="mb4">
              <label>Jumlah Rekod Sepadan : {{data.tak}}</label>
            </w-flex>
            <w-flex justify-space-between class="mb4">
              <label>Jumlah Rekod Ralat : {{data.jumlah}}</label>
            </w-flex>
          </w-card>

        </w-form>

        <w-notification
          v-model="form.sent"
          success
          transition="bounce"
          absolute
          plain
          round
          bottom>
          Borang telah berjaya dihantar
        </w-notification>

    </z-page>

  </zen-one>
</template>

<script>

// import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'

export default {
components: {
  // Vue3ChartJs
},
data() {
  return {
    resourceurl: this.service_penyata+'penyata',
    form: {
      valid: null,
      submitted: false,
      sent: false,
      errorsCount: 0
    },
    validators: {
      required: value => !!value || 'This field is required',
      consent: value => !!value || 'You must agree'
    },
    crumbs: [
          { label: 'iHasil', route: '/' },
          { label: 'Penyata Penyesuaian', route: '/penyesuaian' },
          { label: 'Proses Penyesuaian Manual', route: '/penyesuaian/manual' },
    ],
    showCard: false,
    data : {},
    files:[],
  }},
  methods: {
    onSuccess () {
      setTimeout(() => (this.form.sent = true), 2000)
      // this.$inertia.visit(window.route('penyesuaian.index'));

    },
    upload(){
     
        let formData = new FormData();
        formData.append('file', this.files[0].file)
        formData.append('model', 'App\\Models\\PenyataPenyesuaiaan');
        // formData.append('model_id', id);
        console.log(formData);
        this.$zcomm.post(this.resourceurl+'/upload', formData)
          .then(res => {
            // console.log(res);
            this.data = res
          this.$zutil.notify ("Rekod telah berjaya dihantar")
          // this.$inertia.visit(this.$route('penyesuaian.manual'))
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {

        });
    },
    onValidate () {
      this.form.sent = false
      this.form.submitted = this.form.errorsCount === 0
    }
  }
}

</script>

<style>


</style>